/* 同意の取り扱い — jardin du I'llony
   ga4.js より先に読むこと。Consent Mode v2。

   既定はすべて拒否。日本（Asia/Tokyo）からの閲覧だけは、日本の法令（オプトアウト方式）に
   沿ってその場で有効にする。それ以外の地域にはバナーを出し、押されるまで Cookie を出さない。
   パリ店があり、tojapan と privatelesson は海外の方向けの英語サイトのため。

   **全域でバナーを出したくなったら、下の AUTO_GRANT_TZ を空配列にする。** */
(function () {
  var AUTO_GRANT_TZ = ['Asia/Tokyo'];
  var KEY = 'illony_consent';
  var PRIVACY = 'https://www.illony.com/policies/privacy-policy';

  // 記録は .illony.com の Cookie に置く。localStorage だとサブドメインごとに
  // 別扱いになり、一度お答えいただいた方に sbc・menu・ikusei …と何度も尋ねることになる。
  function host() {
    var h = location.hostname;
    return /(^|\.)illony\.com$/.test(h) ? '; domain=.illony.com' : '';
  }
  function read() {
    var m = document.cookie.match(/(?:^|;\s*)illony_consent=([^;]*)/);
    if (m) return decodeURIComponent(m[1]);
    try { return localStorage.getItem('illony-consent'); } catch (e) { return null; }
  }
  function write(v) {
    try {
      document.cookie = KEY + '=' + v + host() + '; path=/; max-age=' + (60 * 60 * 24 * 365) +
        '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
    try { localStorage.setItem('illony-consent', v); } catch (e) {}
  }

  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 600
  });

  function decide(v) {
    write(v);
    if (v === 'granted') gtag('consent', 'update', { analytics_storage: 'granted' });
  }

  var stored = read();
  if (stored === 'granted') { gtag('consent', 'update', { analytics_storage: 'granted' }); return; }
  if (stored === 'denied') return;

  var tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
  if (AUTO_GRANT_TZ.indexOf(tz) !== -1) { decide('granted'); return; }

  var L = (document.documentElement.lang || navigator.language || 'en').slice(0, 2);
  var T = {
    en: { body: 'We use Google Analytics to see which pages are read. No name, address or e-mail is sent, and we do not use it for advertising.',
          ok: 'Accept', no: 'Decline', more: 'Privacy' },
    fr: { body: 'Nous utilisons Google Analytics pour savoir quelles pages sont lues. Aucun nom, adresse ou e-mail n’est transmis, et nous ne l’utilisons pas pour la publicité.',
          ok: 'Accepter', no: 'Refuser', more: 'Confidentialité' },
    ja: { body: 'どのページが読まれているかを知るために Google アナリティクスを使っています。お名前・ご住所・メールアドレスは送っておらず、広告には使いません。',
          ok: '同意する', no: '同意しない', more: 'プライバシーポリシー' }
  };
  var t = T[L] || T.en;

  function build() {
    var s = document.createElement('style');
    s.textContent =
      '.ilc{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#101C34;color:#E9EDF2;' +
      'font-family:"Shippori Mincho B1","Hiragino Mincho ProN",Georgia,serif;font-size:13px;line-height:1.9;' +
      'padding:18px clamp(16px,4vw,40px);box-shadow:0 -8px 40px rgba(16,28,52,.28)}' +
      '.ilc-in{max-width:1180px;margin:0 auto;display:flex;flex-wrap:wrap;align-items:center;gap:14px 24px}' +
      '.ilc p{margin:0;flex:1 1 320px;opacity:.9}' +
      '.ilc a{color:#A9C3A0;text-decoration:none;border-bottom:1px solid rgba(169,195,160,.5);white-space:nowrap}' +
      '.ilc-b{display:flex;gap:10px;flex:0 0 auto}' +
      '.ilc button{font:inherit;font-size:12px;letter-spacing:.14em;padding:10px 22px;cursor:pointer;' +
      'border:1px solid rgba(233,237,242,.5);background:transparent;color:#E9EDF2;transition:all .35s}' +
      '.ilc button:hover{border-color:#A9C3A0;color:#A9C3A0}' +
      '.ilc button.y{background:#E9EDF2;color:#101C34;border-color:#E9EDF2}' +
      '.ilc button.y:hover{background:#A9C3A0;border-color:#A9C3A0;color:#101C34}' +
      '@media(max-width:560px){.ilc-b{width:100%}.ilc button{flex:1}}';
    document.head.appendChild(s);

    var d = document.createElement('div');
    d.className = 'ilc';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-label', t.ok);
    var p = document.createElement('p');
    p.appendChild(document.createTextNode(t.body + ' '));
    var a = document.createElement('a');
    a.href = PRIVACY; a.rel = 'noopener'; a.textContent = t.more;
    p.appendChild(a);
    var box = document.createElement('div');
    box.className = 'ilc-b';
    var no = document.createElement('button');
    no.textContent = t.no;
    var ok = document.createElement('button');
    ok.className = 'y'; ok.textContent = t.ok;
    no.onclick = function () { decide('denied'); d.remove(); s.remove(); };
    ok.onclick = function () { decide('granted'); d.remove(); s.remove(); };
    box.appendChild(no); box.appendChild(ok);
    var inner = document.createElement('div');
    inner.className = 'ilc-in';
    inner.appendChild(p); inner.appendChild(box);
    d.appendChild(inner);
    document.body.appendChild(d);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
